import React from 'react';
import PropTypes from 'prop-types';

import classes from './columnData.module.css';

const propTypes = {
  top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  bottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

const ColumnDataCell = ({ top, bottom }) => (
  <div className={classes.container}>
    <span className={classes.head}>{top}</span>
    <span className={classes.text}>{bottom}</span>
  </div>
);

ColumnDataCell.propTypes = propTypes;

export default ColumnDataCell;
